const Header = () => {
    return (
        <>
            <header>
                <h1>Pawsitively Fintastic Pets</h1>
                <h2>A Boop Review</h2>
            </header>
        </>
    )
}

export default Header;